<template>
  <div id="vk_like"></div>
</template>

<script>
  import functions from "./functions.js";

  export default {
    mixins: [functions],
    mounted() {
      VK.init({apiId: 7026259, onlyWidgets: true});
      document.getElementById('vk_like').innerHTML = VK.Share.button(
        {
          url: 'http://cvweb.ru',
          title: 'CV Web',
          image: 'https://cvweb.ru/vue/images/share_img_ru.jpg',
          noparse: true
        }, {type: 'custom', text: '<img src="/vue/images/vk.png" id="share-vk">'});

      VK.Observer.subscribe("widgets.like.shared", function f() {
        this.$emit('input', true);
      });
    },
    props: [
      'is_success'
    ],
    methods: {
      shareVk() {
        console.log('ok');
      }
    }
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/share/vk.vue